import './toast.css';

function toast (text, duration) {
  // improve 可以将一些可复用的元素抽离出去，减少重复创建 dom 消耗
  const id = Math.random();
  const fragment = document.createDocumentFragment();
  const container = document.createElement('div');
  container.id = id;
  container.classList.add('bext-toast-container');
  const content = document.createElement('div');
  content.innerText = text;
  content.classList.add('bext-toast-content');
  container.appendChild(content);
  fragment.appendChild(container);
  document.body.appendChild(fragment);

  setTimeout(() => {
    const dom = document.getElementById(id);
    if (dom) {
      dom.style.opacity = 0;
      setTimeout(() => document.body.removeChild(dom), 1000);
    }
  }, duration);
}

export default toast;
